import React, {useContext} from "react";
import { Role } from "../interfaces";
import {Navigate} from "react-router-dom";
import {AuthContext} from "../config/AuthProvider";

interface PrivateRouteProps {
    element: React.ReactElement,
    requiredRoles?: Role[]
}


export default function PrivateRoute({element, requiredRoles}: PrivateRouteProps){

    const {accessData} = useContext(AuthContext)!
    const userRole = accessData?.role


    if(!accessData) {
        return <Navigate to={"/login"}/>
    }


    if (requiredRoles && !requiredRoles.some(role => userRole?.includes(role))) {
        return <Navigate to={"/login"} />;
    }

    return element
}